import { AlarmGroupsDetailsController } from './alarm-groups-details.directive.controller'

import { Enums } from '../../../models/common/enums'

import { LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'

import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { ALARM_GROUP_SERVICE_NAME, AlarmGroupService } from '../../../services/alarm-group/alarm-group.service'
import { ALARM_GROUP_OPERATORS_SERVICE_NAME, AlarmGroupOperatorService } from '../../../services/alarm-group/alarm-group.operator.service'


//#region Asset Imports

import * as TEMPLATE from './alarm-groups-details.tpl.html'

//#endregion

export class AlarmGroupsDetailsDirective implements ng.IDirective {
    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'logger',
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        ALARM_GROUP_SERVICE_NAME,
        ALARM_GROUP_OPERATORS_SERVICE_NAME, (
            $scope,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            userSessionService: UserSessionService,
            alarmGroupService: AlarmGroupService,
            alarmGroupOperatorService: AlarmGroupOperatorService,
        ) => {
            return new AlarmGroupsDetailsController(
                $scope,
                $q,
                $timeout,
                logger,
                localDictionary,
                userSessionService,
                alarmGroupService,
                alarmGroupOperatorService,
                Enums.ReferenceType.IdAlarmGroup,
                Enums.SimaxModuleName.Alarm_Group)
        }]

    controllerAs = '$ctrl'

    template = TEMPLATE
}